import React, { createContext, useContext, useEffect, useState } from 'react';

const BasketContext = createContext();

export const BasketProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [isFetchingPremium, setIsFetchingPremium] = useState(true);
  const [isFetchingExcess, setIsFetchingExcess] = useState(true);
  const [hasVehicles, setHasVehicles] = useState(null);
  const [isFetchError, setIsFetchError] = useState(false);

  return (
    <BasketContext.Provider value={{ 
      cart, 
      setCart, 
      isFetchingPremium, 
      setIsFetchingPremium, 
      isFetchingExcess, 
      setIsFetchingExcess, 
      hasVehicles, 
      setHasVehicles,
      isFetchError,
      setIsFetchError
    }}>
      {children}
    </BasketContext.Provider>
  );
};

export const useBasket = () => useContext(BasketContext);
